// dependencies

// components
import { useNavigate } from "react-router";
import { ArrowSVG } from "../../ui/SVGs";
import ExperienceCard from "./ExperienceCard";


// styles
import styles from "./css/ExperienceSection.module.css";


export default function ExperienceSection() {
    const navigate = useNavigate();

    const handleGetInTouch = () => {
        navigate("/contact");
    }

    return (
        // background
        <div className={styles.aboutSectionContainer}>
            {/* header, text, cards */}
            <div className={styles.contentContainer}>

                {/* header, text */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        Experience
                        <span className={styles.headerDivider}></span>
                    </div>
                    <div className={styles.aboutText}>
                        I'm a passionate developer with experience building web and mobile applications. I love creating elegant solutions to complex problems.
                        <br />
                        <span className={styles.ctaLine}>
                            Currently open to new opportunities — 
                            <button className={styles.getInTouchBtn} onClick={handleGetInTouch}>
                                Get in Touch <ArrowSVG />
                            </button>
                        </span>
                    </div>
                </div>

                {/* cards */}
                <div className={styles.experienceCardsContainer}>
                    <ExperienceCard
                        key={1}
                        workName={"Hayes Hip and Elbow Scoring"}
                        workTitle={"Freelance Full-Stack Website Developer"}
                        developmentPeriod={"March 2026 - Current"}
                        expText={"Developing a full-stack web platform for a veterinary specialist to manage canine hip and elbow scoring submissions within the Dogs Australia ORCHID/CHED scheme. I’m responsible for the project end to end, including requirements, architecture, UI development, backend systems, database design, file storage, payments, transactional email, documentation, deployment, and ongoing client support. The platform uses Next.js and TypeScript with Firestore and AWS S3, and includes multi-dog submission workflows, Stripe payments, invoice-based clinic billing, large DICOM image uploads, and event-driven and scheduled email processing."}
                        linkToProject={"https://www.codenamehaar.dev/projects/B6fHQMXeMbVwCWmQvJDm"}
                    />
                    <ExperienceCard
                        key={2}
                        workName={"Ascolta Women Inc."}
                        workTitle={"Freelance Website Developer"}
                        developmentPeriod={"June 2025 - June 2026"}
                        expText={"Designed and built a website on Squarespace, writing custom code to work around the platform's restrictive built-in styling to achieve a bespoke look. Successfully launched the website in 2026."}
                        linkToProject={"https://www.codenamehaar.dev/projects/GxIUnErfVkJeFBxr6AXB"}
                    />
                    <ExperienceCard
                        key={3}
                        workName={"Finn Creative Inc."}
                        workTitle={"Freelance Full Stack Developer"}
                        developmentPeriod={"March 2025 - April 2025"}
                        expText={"I designed and developed a full-stack web platform for a dramatherapist, featuring a client booking system, admin dashboard, secure Stripe payments, and live Google Calendar integration. I handled UI/UX design in Figma, managed the development process in Trello, and used Git branching to keep the codebase clean. The platform supports session management, customer info collection, and admin approval workflows, delivering a smooth and maintainable user experience."}
                        linkToProject={"https://www.codenamehaar.dev/projects/84dFy4ilSEDQUOP1YoHa"}
                    />
                    <ExperienceCard
                        key={4}
                        workName={"HOPE Project Cambodia"}
                        workTitle={"Freelance Web Developer"}
                        developmentPeriod={"February 2024 - July 2024"}
                        expText={"I developed a clean, accessible Wix website for a grassroots NGO focused on youth education and empowerment in rural Cambodia. Working closely with the client, I led the planning, created wireframes and mockups, and iterated through design feedback to reflect the project’s values of compassion and sustainability. I ensured the site was easy for the team to manage and integrated calls-to-action that directed visitors to their social enterprise store to support ongoing programs."}
                        linkToProject={"https://www.codenamehaar.dev/projects/pHVaEPKDYLtcp3D2Sir9"}
                    />
                    <ExperienceCard
                        key={5}
                        workName={"Paul Haar Architect"}
                        workTitle={"Freelance Web Developer"}
                        developmentPeriod={"November 2019 - February 2020"}
                        expText={"I designed and built this website using Wix before learning to code, experimenting with layout, interactivity, and multimedia integration. I edited and embedded videos using Premiere Pro, showcasing the client’s architectural work, values of sustainability, and collaborations with Indigenous communities. This early project taught me practical lessons in user experience, content structuring, and adapting design to real-world constraints."}
                        linkToProject={"https://www.codenamehaar.dev/projects/9b7biRqUrjgUfs3oqiCg"}
                    />
                </div>
            </div>
        </div>
    );
}

